<script>
  import ShowDocument from "./ShowDocument.svelte";
  import PrivacyTermsAndConditions from "./PrivacyTermsAndConditions.svelte";
  import { _, locale, locales } from "svelte-i18n";
  import { localeLabels } from "../i18n";

  export let active;
  export let user;
  export let updateUser;
  export let showErrorMessage = false;
  export let isLoading = false;
  let inProgress = false;
  let showReportWithType = false;

  if (!isLoading && active && user !== undefined && user.consent === false) {
    window.document.body.classList.toggle("modal-is-active");
  } else {
    window.document.body.classList.remove("modal-is-active");
  }
  if (!(!isLoading && active && user !== undefined && user.consent === false)) {
    window.document.body.classList.remove("modal-is-active");
  }
  function save() {
    inProgress = true;
    updateUser(user)
      .then((success) => {
        window.document.body.classList.remove("modal-is-active");
        inProgress = false;
      })
      .catch((error) => {
        inProgress = false;
        console.log("Not able to create user", error);
      });
  }
</script>

{#if active && user !== undefined && user.consent === false}
  <div class="modal">
    <div class="modal__backdrop" />
    <div class="modal__wrapper">
      <div
        class="modal__content"
        style="animation: 0s ease 0s 1 normal none running none;"
      >
        <div>
          <header class="modal__header">
            <h1 class="h2">{$_("profile.form.privacy.modal.title")}</h1>
          </header>
          <div class="modal__body">
            <form>
              <label
                style="margin-left:30px;margin-top:10px;"
                for="lang"
                class="select"
                ><h1 class="layout__title">{$_("profile.language")}</h1>
                <span class="select__button" style="width: 200px;">
                  <select
                    style="width: 200px;"
                    on:change={(e) =>
                      localStorage.setItem("language", e.target.value)}
                    bind:value={$locale}
                  >
                    {#each $locales as locale}
                      <option value={locale}
                        >{localeLabels.find((item) => item.value === locale)
                          .label}</option
                      >
                    {/each}
                  </select>
                </span>
              </label>
              <PrivacyTermsAndConditions
                bind:user
                bind:showReportWithType
                {showErrorMessage}
              />
              <fieldset class="form-section form-section--submit">
                <p class="warning"></p>
                <div class="layout-buttons layout-buttons--left-right">
                  <button type="button" class="button-text button-text--cancel">
                    <a
                      href="sms:+4790508006;?&body=Hei! Jeg vil slette mine data fra treningsdagboken. Referanse til mine data er: {user.id}."
                      >{$_("profile.form.privacy.modal.delete")}</a
                    ></button
                  >
                  <button
                    on:click={save}
                    type="button"
                    disabled={inProgress}
                    class="button button--icon {user.id !== undefined
                      ? 'button--icon-check'
                      : 'button--icon-link'} {inProgress
                      ? 'button--disabled'
                      : ''}">{$_("generic.buttons.save")}</button
                  >
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  {#if showReportWithType}
    <ShowDocument
      active={showReportWithType}
      onClose={() => (showReportWithType = false)}
      documentType={showReportWithType}
    />
  {/if}
{/if}
